module.exports = __webpack_public_path__ + "static/media/slide1.8a6d6f2f.svg";